(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/core/jupiter/assets/javascripts/jupiter.js') >= 0) return;  svs.modules.push('/components/core/jupiter/assets/javascripts/jupiter.js');
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(fn) { try { return Function.toString.call(fn).indexOf("[native code]") !== -1; } catch (e) { return typeof fn === "function"; } }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

svs = svs || {};
var HTTPError = function (_Error) {
  function HTTPError(obj) {
    var _this;
    _classCallCheck(this, HTTPError);
    _this = _callSuper(this, HTTPError, [obj.message]);
    _this.code = obj.code;
    _this.reqId = obj.reqId;
    return _this;
  }
  _inherits(HTTPError, _Error);
  return _createClass(HTTPError);
}( _wrapNativeSuper(Error));
(function (svs) {
  'use strict';

  var apiUrl = svs.core.jupiter.data.url;
  svs.core.jupiter = function () {
    var logger = new svs.core.log.Logger('component:core.jupiter');
    var sessionTimeMs;
    var realityCheckMsg;
    if (svs && svs.core && svs.core.data) {
      sessionTimeMs = svs.core.data.sessionTimeMs;
      realityCheckMsg = svs.core.data.rcmsg;
      if (realityCheckMsg) {
        logger.debug("Found rcmsg from server with id: ".concat(realityCheckMsg.messageId));
      }
    }
    var sendRpp = function sendRpp(path) {
      var requestCount = path.split('|').length;
      var isMultiFetch = false;
      if (path.indexOf('multifetch') > -1) {
        isMultiFetch = true;
      }
      svs.events.publish('/core/rpp', {
        requestCount: requestCount,
        isMultiFetch: isMultiFetch
      });
    };
    return {
      parseErrorResponse: function parseErrorResponse(response) {
        var params;
        var jsonResp = response && response.responseJSON ? response.responseJSON : null;
        if (jsonResp && jsonResp.error) {
          if (jsonResp.error) {
            if (jsonResp.error.code) {
              params = {};
              params.code = jsonResp.error.code;
            }
            if (jsonResp.error.requestId) {
              params = params || {};
              params.reqId = jsonResp.error.requestId;
            }
            if (jsonResp.error.message) {
              params = params || {};
              params.message = decodeURI(jsonResp.error.message);
            }
          }
        } else if (jsonResp && jsonResp.status) {
          if (jsonResp.status.code) {
            params = {};
            params.code = jsonResp.status.code;
          }
          if (jsonResp.status.description) {
            params = params || {};
            params.description = jsonResp.status.description;
          }
          if (jsonResp.message) {
            params = params || {};
            params.message = jsonResp.message;
          }
        }
        return params;
      },
      url: function url() {
        return apiUrl;
      },
      multiFetch: function multiFetch(paths) {
        var serial = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        for (var i = 0; i < paths.length; i++) {
          paths[i] = encodeURIComponent(paths[i]);
        }
        return "".concat(this.url(), "/multifetch?serial=").concat(serial, "&urls=").concat(paths.join(encodeURIComponent('|')));
      },
      call: function call(options, successCallback, errorCallback) {
        var _svs$core$observabili;
        var self = this;
        var _ref = (_svs$core$observabili = svs.core.observability) !== null && _svs$core$observabili !== void 0 ? _svs$core$observabili : {},
          provider = _ref.provider,
          inject = _ref.inject,
          SpanKind = _ref.SpanKind,
          apiContext = _ref.context;
        var tracer = provider === null || provider === void 0 ? void 0 : provider.getTracer();
        var spanMethod = (options.method || 'GET').toUpperCase();
        var span = tracer === null || tracer === void 0 ? void 0 : tracer.startSpan(spanMethod, {
          kind: SpanKind.CLIENT
        }, apiContext.active());
        span === null || span === void 0 || span.setAttribute('http.method', spanMethod);
        span === null || span === void 0 || span.setAttribute('http.url', options.path);
        span === null || span === void 0 || span.setAttribute('http.host', self.url());

        var doCall = function doCall(options, successFunction, errorFunction) {
          var headers = inject ? inject({}, span) : {};
          var ajaxOpts = {
            type: options.method,
            url: self.url() + options.path,
            dataType: 'json',
            data: options.data,
            cache: false,
            timeout: svs.core.config.data.svsconfig.clientAjaxTimeout,
            xhrFields: {
              withCredentials: true
            },
            success: successFunction,
            error: errorFunction,
            context: options.context,
            headers: headers
          };
          sendRpp(options.path);
          if (options.ghost) {
            ajaxOpts.headers = ajaxOpts.headers || [];
            ajaxOpts.headers['X-Casper'] = 'true';
          } else {
            ajaxOpts.complete = function (xhr, status) {
              if (xhr && xhr.getResponseHeader('x-casper')) {
                setTimeout(haunt, 0, options);
              }
              if (options.complete) {
                options.complete(xhr, status);
              }
            };
          }
          if (options.method.toLowerCase() !== 'get') {
            if (options.data instanceof FormData) {
              ajaxOpts.contentType = false;
            } else {
              ajaxOpts.contentType = 'application/json';
              if (typeof options.data !== 'string') {
                ajaxOpts.data = JSON.stringify(options.data);
              }
            }
            ajaxOpts.processData = false;
            ajaxOpts.crossDomain = true;
          } else {
            ajaxOpts.contentType = 'text/plain';
          }
          return $.ajax(ajaxOpts);
        };

        var onSuccess = function onSuccess(response, status, xhr) {
          logger.debug("Jupiter call success ".concat(options.method, " ").concat(options.path));
          span === null || span === void 0 || span.setAttribute('http.status_code', xhr.status);
          span === null || span === void 0 || span.end();
          svs.events.publish('/core/jupiter/response', xhr.status);
          response = response || {};
          if (response.responses) {
            sessionTimeMs = response.responses[0].requestInfo && response.responses[0].requestInfo.sessionTimeMs;
          } else {
            sessionTimeMs = response.requestInfo && response.requestInfo.sessionTimeMs;
          }
          realityCheckMsg = response.rcmsg ? response.rcmsg : undefined;
          if (sessionTimeMs) {
            svs.events.publish('/core/jupiter/sessionTimeMs', sessionTimeMs);
          }
          if (xhr.getResponseHeader('X-RC-Messageid') || xhr.getResponseHeader('X-RC-Payload')) {
            logger.debug("Received rcmsg with id: ".concat(xhr.getResponseHeader('X-RC-Messageid')));
            realityCheckMsg = {
              messageId: xhr.getResponseHeader('X-RC-Messageid'),
              payload: xhr.getResponseHeader('X-RC-Payload')
            };
            svs.events.publish('/componets/realitycheck/message', realityCheckMsg);
          }
          if (successCallback) {
            response = JSON.parse(JSON.stringify(response), function (key, value) {
              if (key === 'sessionId' || key === 'deviceId') {
                return '[hidden]';
              }
              return value;
            });
            successCallback.call(options.context, response, status, xhr);
          }
        };

        var onError = function onError(xhr, status, err) {
          var errorCode;
          if (xhr.status === 0 && status === 'timeout') {
            xhr.status = 408;
            errorCode = 408;
          } else if (xhr.status > 0 && xhr.status < 599) {
            errorCode = xhr.status;
          } else {
            errorCode = 666;
          }
          span === null || span === void 0 || span.setAttribute('error', true);
          span === null || span === void 0 || span.setAttribute('http.status_code', xhr.status);
          span === null || span === void 0 || span.addEvent("Error http status was ".concat(xhr.status));
          span === null || span === void 0 || span.end();
          var logMsg = "Jupiter call failed ".concat(xhr.status, " (").concat(options.method, " ").concat(options.path, ")");
          if (!xhr.responseJSON) {
            if (err === '' && status === 'error' && xhr.status === 0) {
              logMsg += ', Potential network error';
            } else {
              logMsg += ", Message:".concat(err);
            }
            logMsg += ", Status:".concat(status, ", XhrStatus:").concat(xhr.status, ", XhrText:").concat(xhr.responseText);
            if (xhr.status >= 300 && xhr.status < 500) {
              logger.info(logMsg);
            } else {
              logger.error(logMsg);
            }
            var customErrorObject = {
              error: {
                code: errorCode,
                message: "Trinidad Error : ".concat(err)
              }
            };
            xhr.responseJSON = customErrorObject;
            xhr.responseText = JSON.stringify(customErrorObject);
          } else if (xhr.status >= 300 && xhr.status < 500) {
            logger.info("".concat(logMsg, ", Message:").concat(err), self.parseErrorResponse(xhr));
          } else {
            logger.warn("".concat(logMsg, ", Message:").concat(err), self.parseErrorResponse(xhr));
          }
          svs.events.publish('/core/jupiter/response', xhr.status);
          if (errorCallback) {
            errorCallback.call(options.context, xhr, status, err);
          }
        };

        var onErrorExt = function onErrorExt(xhr, status, err) {
          var errCodeStr;
          var errCode;
          switch (xhr.status) {
            case 400:
              if (xhr.responseJSON && xhr.responseJSON.error) {
                errCodeStr = String(xhr.responseJSON.error.code);
                errCode = parseInt(errCodeStr.replace(/\s/g, ''), 10);
                switch (errCode) {
                  case 3107:
                    logger.info("Client tries to access protected path unauthorized in ASM, path: ".concat(options.path));
                    svs.core.userSession.logout(svs.core.userSession.logoutReason.INVALID_SESSION);
                    break;
                  case 100005:
                    logger.info("Client tries to access protected path unauthorized, path: ".concat(options.path));
                    break;
                  default:
                    onError(xhr, status, err);
                }
              } else {
                onError(xhr, status, err);
              }
              break;
            case 401:
              logger.info("Client has invalid session, path: ".concat(options.path));
              svs.core.userSession.logout(svs.core.userSession.logoutReason.INVALID_SESSION);
              break;
            case 403:
              logger.info("Client tries to access protected path unauthorized, path: ".concat(options.path));
              onError(xhr, status, err);
              break;
            case 500:
              if (xhr.responseJSON && xhr.responseJSON.error) {
                errCodeStr = String(xhr.responseJSON.error.code);
                errCode = parseInt(errCodeStr.replace(/\s/g, ''), 10);
                switch (errCode) {
                  case 3107:
                    logger.info("Client tries to access protected path unauthorized in ASM, path: ".concat(options.path));
                    svs.core.userSession.logout(svs.core.userSession.logoutReason.INVALID_SESSION);
                    break;
                  case 100005:
                    logger.info("Client tries to access protected path unauthorized ASM, path: ".concat(options.path));
                    break;
                  default:
                    onError(xhr, status, err);
                }
              } else {
                onError(xhr, status, err);
              }
              break;
            default:
              onError(xhr, status, err);
          }
        };

        var haunt = function haunt(options) {
          options.ghost = true;
          doCall(options, function (response, status) {
            logger.debug("Received Ghost response. Status: ".concat(status, ". Uri: ").concat(options.method, " ").concat(options.path));
          }, function (xhr, status) {
            logger.warn("Received Ghost response with error. Status: ".concat(status, ". Uri: ").concat(options.method, " ").concat(options.path));
          });
        };

        if (!Object.prototype.hasOwnProperty.call(options, 'useExtErrFunc')) {
          options.useExtErrFunc = true;
        }
        if (options.useExtErrFunc) {
          return doCall(options, onSuccess, onErrorExt);
        }
        return doCall(options, onSuccess, onError);
      },
      callParallel: function callParallel(paths, success, error, limit, executeError) {
        var self = this;
        var responses = [];
        var localPaths = paths || [];
        var noop = function noop() {};
        success = success || noop;
        error = error || noop;
        executeError = executeError !== false; 

        limit = limit || 10; 

        if (!localPaths.length || typeof success !== 'function' || typeof error !== 'function') {
          logger.debug('Invalid parameters.', localPaths, success, error);
          return;
        }
        this.eachLimit(localPaths, limit, function (path, callback) {
          self.call({
            method: 'GET',
            path: path
          }, function (response) {
            responses.push({
              path: path,
              data: response
            });
            callback();
          }, function (xhr, status, err) {
            if (executeError) {
              callback(xhr, status, err);
            } else {
              callback();
            }
          });
        }, function (xhr, status, err) {
          if (executeError && xhr && xhr.responseJSON && xhr.responseJSON.error) {
            error(xhr, status, err);
          } else {
            success(responses);
          }
        });
      },
      eachLimit: function eachLimit(arr, limit, iterator, callback) {
        callback = callback || function () {};
        if (!arr.length || limit <= 0) {
          return callback();
        }
        var completed = 0;
        var started = 0;
        var running = 0;
        (function replenish() {
          if (completed >= arr.length) {
            return callback();
          }
          function iteratorFn(xhr, status, err) {
            if (err) {
              callback(xhr, status, err);
              callback = function callback() {};
            } else {
              completed += 1;
              running -= 1;
              if (completed >= arr.length) {
                callback();
              } else {
                replenish();
              }
            }
          }
          while (running <= limit && started < arr.length) {
            started += 1;
            running += 1;
            iterator(arr[started - 1], iteratorFn);
          }
        })();
      },
      getSessionTimeMs: function getSessionTimeMs() {
        return sessionTimeMs;
      },
      getRealityCheckMsg: function getRealityCheckMsg() {
        return realityCheckMsg;
      },
      callAsync: function callAsync(options) {
        var _this2 = this;
        return new Promise(function (resolve, reject) {
          _this2.call(options, function (response, status, xhr) {
            resolve({
              response: response,
              status: status,
              xhr: xhr
            });
          }, function (xhr) {
            var errObj = _this2.parseErrorResponse(xhr);
            reject(new HTTPError(errObj));
          });
        });
      }
    };
  }();
  ['get', 'post', 'delete', 'put'].forEach(function (method) {
    svs.core.jupiter[method] = function (options, successCallback, errorCallback) {
      if (_typeof(options) === 'object') {
        options.method = method;
      }

      if (typeof options === 'string') {
        options = {
          path: options,
          method: method
        };
      } else if (method === 'get' && Array.isArray(options)) {
        options = {
          path: "/multifetch?urls=".concat(options.join('|')),
          method: method
        };
      }
      return this.call(options, successCallback, errorCallback);
    };
  });
})(svs);

 })(window);